import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { LoginUser } from "./types/users";

export const useUserAuth = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const loginAdmin = useMutation({
    mutationFn: async (user: { loginId: string; password: string }) => {
      try {
        localStorage.removeItem("R_M_t");
        localStorage.removeItem("R_M_uid");

        const response = await axios.post(`/login`, user);
        const expiryTime = new Date().getTime() + 28 * 24 * 60 * 60 * 1000;

        localStorage.setItem("R_M_exp", JSON.stringify(expiryTime));
        localStorage.setItem("R_M_t", response.data.data.token);
        localStorage.setItem("R_M_uid", response.data.data.userId);

        return response.data;
      } catch (error) {
        console.error("Error login user:", error);
        throw error;
      }
    },

    onError: (error) => {
      toast.error(
        error.message
          ? `${error.message}`
          : "Sorry, Failed to Login, please try again"
      );
    },

    onSettled: (res) => {
      if (res) {
        toast.success("User has successfully Logged in...");
      }
    },

    // onSuccess: () => {
    //   queryClient.invalidateQueries(["payments"]); // Refresh payments data
    // },
  });

  const logout = useMutation({
    mutationFn: async () => {
      try {
        const token = localStorage.getItem("R_M_t");
        const response = await axios.get(`/logout?token=${token}`);
        //console.log(response);
        return response.data;
      } catch (error) {
        console.error("Error logout user:", error);
        throw error;
      }
    },
    onSettled: (res) => {
      localStorage.removeItem("R_M_t");
      localStorage.removeItem("R_M_uid");
      navigate("/");
      toast.success("User has successfully Logout in...");
    },

    onError: (error) => {
      toast.error(error.message ?? "Sorry, Failed to Login, please try again");
    },
    // onSuccess: () => {
    //   queryClient.invalidateQueries(["payments"]); // Refresh payments data
    // },
  });

  const User = (id: any) => {
    return useQuery({
      queryKey: ["users", id], // Include id in queryKey
      queryFn: async () => {
        try {
          const response = await axios.get(`/api/v1/userById/${id}`);
          return response.data.data as LoginUser;
        } catch (error) {
          console.error("Error fetching users:", error);
          throw error;
        }
      },
      staleTime: 30000,
      retry: false,
    });
  };

  const Logout = () => {
    return useQuery({
      queryKey: ["log-out"],
      queryFn: async () => {
        try {
          const token = localStorage.getItem("R_M_t");
          if (!token) {
            navigate("/");
            return;
          }
          await axios
            .get(`/logout`, {
              params: {
                token: token,
              },
            })
            .then(() => {
              localStorage.removeItem("R_M_t");
              localStorage.removeItem("R_M_uid");
              navigate("/");
            });
          return;
        } catch (error) {
          console.error("Error logout:", error);
          throw error;
        }
      },
      retry: false,
      staleTime: 30000,
    });
  };

  return { loginAdmin, logout, User, queryClient, Logout };
};
